/*
|--------------------------------------------------------------------------
| Site Forms: Newsletter Modal Form
|--------------------------------------------------------------------------
*/

__gh__webApp.siteForms.newsletterModalForm = {

	/**
	 * Initialize newsletter modal form
	 */
	"init": function(){
		if (this.isDisabled()) {return;}
		this.checkCookie();
	},

	"setCookie": function(options){
		var commonJS  = __gh__webApp.common,
		 	baseURL   = __gh__coreData.siteData.baseURL,
		 	pageViews = ("pageViews" in options) ? options.pageViews : null,
		 	expires   = ("expires" in options) ? options.expires : 1;
		 	console.log("setCookie");
		commonJS.setCookie({
			"name"		: "__gh__cookie_newsletterModal", 
			"value"		: {"pageViews":pageViews,"expires":expires},
			"domain"	: baseURL.replace("http://",""),
			"expires"	: expires
		});
	},
	
	/**
	 * Check if it's disabled
	 */
	"checkCookie": function(){
		var thisObject      	= __gh__webApp.siteForms.newsletterModalForm,
			commonJS			= __gh__webApp.common,
			modalFormCookie		= commonJS.getCookie("__gh__cookie_newsletterModal"),
			modalFormCookie 	= (modalFormCookie) ? JSON.parse(modalFormCookie) : modalFormCookie,
			pageViews			= (modalFormCookie) ? modalFormCookie.pageViews + 1 : 1;
			expires				= (modalFormCookie) ? modalFormCookie.expires : 1;
			thisObject.setCookie({"pageViews":pageViews,"expires":expires});
		if (pageViews == 2){
			__gh__webApp.siteForms.newsletterModalForm.showFormWithDelay();
		}	
	},
	
	
	/**
	 * Show form error
	 */
	"showFormError":function($form,message){
		$form.before('<div class="form-error"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>'+ message +'</div>');
		$form.find("[name=email]").addClass("form-error-field");
	},
	
	
	/**
	 * Remove form error
	 */
	"removeFormError": function($form){
		$(".modal-newsletter").find(".form-error").remove();
		$form.find("[name=email]").removeClass("form-error-field");
	},
	
	
	/**
	 * Show newsletter modal on delay
	 */
	"showFormWithDelay": function(){
		var thisObject = __gh__webApp.siteForms.newsletterModalForm;
		setTimeout(function(){ 
			thisObject.showForm();
		}, 5000);
	},
	
	
	/**
	 * Show Modal Form
	 */
	"showForm": function(){
		var thisObject 	= __gh__webApp.siteForms.newsletterModalForm,
			baseURL 	= __gh__coreData.siteData.baseURL,
			formURL 	= baseURL +"/section/?template=HTML_newsletter-modal-form";
			
			
		__gh__webApp.utilities.modal.openModal({
			"url": formURL,
			"callback": function(){
				thisObject.bindEvents();
			}
		});
		
	},
	
	
	/**
	 * Submit form
	 */
	"submitForm": function($newsletterForm){

		var thisObject	= __gh__webApp.siteForms.newsletterModalForm,
			baseURL 	= __gh__coreData.siteData.baseURL,
			thankYouURL = baseURL +"/section/?template=HTML_newsletter-modal-form-thank-you",
			trackNewsletterSignUp = __gh__webApp.utilities.tracker.trackNewsletterSignUp,

			sfEmail = document.getElementById('Email').value,
			sfData  = "[{\"Keys\":{\"PROD_CODE\":\""+sfProdCode+"\",\"Email_Address\":\""+sfEmail+"\"},\"Values\":{\"Email_Address\":\""+sfEmail+"\"}}]";

		$('#errormsg1').html('');

		//Show loading graphic
		$newsletterForm.find("button").html('<i class="fa fa-spinner fa-spin fa-fw"></i>');

	    $.ajax({
	        type: 'post',
	        url: 'http://redesign.gatehousemedia.com/david/salesforceRegister.php',
	        data: {"sfData":sfData},
	        success: function( data ) {
	            if(data.indexOf("errorcode") > -1) {
					$('#errormsg1').html('Email address is not valid. Please try again.');
					//Change loading graphic back to Subscribe button
					$newsletterForm.find("button").html('Subscribe');
					console.log("payload error: "+data);
	            } else {
					//Replace the modal content area with success message
					__gh__webApp.utilities.fetch.html.get({
						"dom":"#modal-h8f78feh8e7dhsw .modal-inner",
						"url":thankYouURL
					});
					thisObject.setCookie({"pageViews":3,"expires":180});
					console.log("payload: "+data);
	            }
	        }
	    });					

	},
	
	
	/**
	 * Bind events
	 */
	"bindEvents": function(){
		var thisObject				= __gh__webApp.siteForms.newsletterModalForm,
			commonJS				= __gh__webApp.common,
			$newsletterForm 		= $("form#newsletter-modal-form");
			$emailField 			= $newsletterForm.find("[name=email]");
			
		$newsletterForm.submit(function(event){
			event.preventDefault();
			thisObject.submitForm($newsletterForm);
			return;			
		});
	},
	
	
	/**
	 * Check to see if it's disabled
	 */
	"isDisabled": function(){
		 var commonJS 					= __gh__webApp.common,
		 	 hasProdCode 				= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"analytics.salesforce.prodcode"),
		 	 isNewsletterModalDisabled	= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"analytics.salesforce.isNewsletterModalDisabled");
		 	 isUserLoggedIn				= __gh__webApp.paywall.isUserLoggedIn();
		 return (!hasProdCode || isNewsletterModalDisabled || isUserLoggedIn);
		 
	 }

};
